type Props = {
  value?: string[]
  onChange: (val: string[] | undefined) => void
}

export function KeywordsInput({ value, onChange }: Props) {
  const input = (value || []).join(', ')

  function parseValue(nextValue: string) {
    const trimmed = nextValue.trim()
    if (!trimmed) {
      onChange(undefined)
    } else {
      onChange(trimmed.split(',').map((k) => k.trim()).filter(Boolean))
    }
  }

  return (
    <input
      value={input}
      onChange={(e) => parseValue(e.target.value)}
      placeholder="e.g. Star Wars, UCS"
    />
  )
}
